export default {
  title: 'My messages',
  badgeType: 'Messages',
};
